import * as React from 'react';

import { translate } from '~l10n/client';

import { IconDownload } from '~shared/components/icons/standard';

import { ExportFeedback } from './ExportFeedback';
import { Download, Pending } from './ExportFeedbackIcons';
import { Spinner } from '~shared/components/Spinner';

const ExportFeedbackDownloadComplete = ({
  onBack,
}: {
  onBack?: () => void;
}) => (
  <ExportFeedback
    onBack={onBack}
    icon={<Download />}
    title={translate('Downloading')}
    message={translate('Your download will begin shortly.')}
  />
);

const ExportFeedbackDownloadInProgress = ({
  onBack,
}: {
  onBack?: () => void;
}) => (
  <ExportFeedback
    onBack={onBack}
    icon={<Pending />}
    title={translate('Preparing')}
    message={translate(
      'This may take a few minutes for large activities. Feel free to continue using Socrative while you wait for your download to begin.'
    )}
  />
);

const AssessmentsExportFeedbackDownloadComplete = ({
  onDownload,
}: {
  onDownload: () => void;
}) => (
  <ExportFeedback
    icon={<Download />}
    title={translate('Report is ready')}
    message={translate('Your document is ready to download')}
    actionButtonProps={{
      label: translate('Download'),
      onClick: onDownload,
      icon: <IconDownload />,
    }}
  />
);

const AssessmentsExportFeedbackDownloadInProgress = ({
  onCancel,
}: {
  onCancel: () => void;
}) => (
  <ExportFeedback
    icon={<Spinner />}
    title={translate('Preparing')}
    message={translate('This may take a few minutes for large activities.')}
    actionButtonProps={{
      label: translate('Cancel'),
      onClick: onCancel,
    }}
  />
);

export {
  ExportFeedbackDownloadComplete,
  ExportFeedbackDownloadInProgress,
  AssessmentsExportFeedbackDownloadComplete,
  AssessmentsExportFeedbackDownloadInProgress,
};
